export default "__VITE_ASSET__Dj8NVb7O__"